import { render, staticRenderFns } from "./KerbPainting.vue?vue&type=template&id=fee4448a"
import script from "./KerbPainting.vue?vue&type=script&lang=js"
export * from "./KerbPainting.vue?vue&type=script&lang=js"
import style0 from "./KerbPainting.vue?vue&type=style&index=0&id=fee4448a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports